import {
	ClientPropertyBuildingDispositionEnum,
	ClientPropertyBuildingMaterialEnum,
	type ClientPropertyCottageDetailResponseDTO,
	type ClientPropertyFlatDetailResponseDTO,
	type ClientPropertyHouseDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { PageResources } from "web_myplann/Portfolio/Components/PropertySections/House";

type BuildingDetail =
	| ClientPropertyHouseDetailResponseDTO
	| ClientPropertyCottageDetailResponseDTO
	| ClientPropertyFlatDetailResponseDTO;

export const getBuildingMaterial = (
	data: BuildingDetail,
	t: (key: string) => string,
) => {
	return data?.buildingMaterial === ClientPropertyBuildingMaterialEnum.Custom
		? data.customBuildingMaterial
		: data?.buildingMaterial
			? t(PageResources.Property.BuildingMaterialValue[data.buildingMaterial])
			: "";
};

export const getDisposition = (
	data: BuildingDetail,
	t: (key: string) => string,
) => {
	return data?.disposition === ClientPropertyBuildingDispositionEnum.Custom
		? data.customDisposition
		: data?.disposition
			? t(PageResources.Property.DispositionValue[data.disposition])
			: "";
};
